import React, { useEffect, useRef, useState } from "react";
import { Box, TextField, Button, InputAdornment, Grid } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import {
  onGetMobileCoupon_Delete,
  onGetMobileCoupon_GetRow,
  onGetMobileCoupon_MobileNumberSearch,
  onGetMobileCoupon_Update,
} from "./MobileCoupenAction";
import {
  fAlertToast,
  fKeyTabInput,
  fcheck_null_undefine_replace_empty,
} from "../../Utility/Utilitys";
import { useSelector } from "react-redux";

const MobileCoupon = () => {
  const intialState = {
    mobileNumber: "",
    couponNumber: "",
    narration1: "",
    narration2: "",
    narration3: "",
  };
  // State for inputs and grid data
  const [couponDetail, setCouponDetail] = useState(intialState);
  const [gridData, setGridData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [mobileError, setMobileError] = useState("");
  const [couponError, setCouponError] = useState("");
  const [narration1Error, setNarration1Error] = useState("");
  const [rows, setRows] = useState([]);
  const vRdxuserInfo = useSelector((state) => state.login.value);

  // Define columns for the DataGrid.
  const columns = [
    { field: "MobileNumber", headerName: "Mobile.No", width: 100 },
    { field: "CouponNumber", headerName: "Coupon.No", width: 150 },
  ];
  const rowsColumn = [
    { field: "MobileNumber", headerName: "Mobile.No", width: 100 },
    { field: "CouponNumber", headerName: "Coupon.No", width: 150 },
    { field: "Narration1", headerName: "Narration1", width: 150 },
    { field: "Narration2", headerName: "Narration2", width: 150 },
    { field: "Narration3", headerName: "Narration3", width: 150 },
    { field: "IsRedeem", headerName: "IsRedeem", width: 80 },
  ];

  // Mobile number must be exactly 10 digits (for the input without country code)
  const mobileRegex = /^\d{10}$/;
  const mobileInputRef = useRef(null);

  useEffect(() => {
    mobileInputRef.current?.focus();
  }, []);
  // onBlur handler for mobile number input with validation
  const handleMobileBlur = async () => {
    const trimmedMobile = couponDetail.mobileNumber.trim();
    if (!trimmedMobile) {
      setMobileError("Mobile number is required");
      return;
    }
    if (!mobileRegex.test(trimmedMobile)) {
      setMobileError("Enter a valid mobile number (10 digits)");
      return;
    }
    setMobileError("");

    const obj = { MobileNumber: trimmedMobile };

    const response = await onGetMobileCoupon_MobileNumberSearch(
      fcheck_null_undefine_replace_empty(obj)
    );
    if (response?.status === 200 && response?.data?.ResultSet) {
      console.log("handleMobileBlur", response?.data?.ResultSet);
      setGridData(response?.data?.ResultSet);
    } else {
      setGridData([]);
    }
  };

  // onBlur handler for coupon number input to show error immediately
  const handleCouponBlur = () => {
    const trimmedCoupon = couponDetail.couponNumber.trim();
    if (!trimmedCoupon) {
      setCouponError("Coupon number is required");
    } else {
      setCouponError("");
    }
  };
  const handleFazaaBlur = () => {
    const trimmedFazaa = couponDetail.narration1.trim();
    if (!trimmedFazaa) {
      setNarration1Error("Fazaa card number is required");
    } else {
      setNarration1Error("");
    }
  };

  // Validate inputs before saving
  const validateInputs = () => {
    let valid = true;
    const trimmedMobile = couponDetail.mobileNumber.trim();
    const trimmedCoupon = couponDetail.couponNumber.trim();
    const trimmedFazaa = couponDetail.narration1.trim();

    if (!trimmedMobile) {
      setMobileError("Mobile number is required");
      valid = false;
    } else if (!mobileRegex.test(trimmedMobile)) {
      setMobileError("Enter a valid mobile number (10 digits)");
      valid = false;
    }

    if (!trimmedCoupon) {
      setCouponError("Coupon number is required");
      valid = false;
    }
    if (!trimmedFazaa) {
      setNarration1Error("Fazaa card number is required");
      valid = false;
    }

    return valid;
  };

  // onClick handler for Save button
  const handleSave = async () => {
    let iValidateDetail = validateInputs();
    if (!iValidateDetail) return;

    setSaving(true);
    const obj = {
      MobileNumber: couponDetail.mobileNumber.trim(),
      CouponNumber: couponDetail.couponNumber.trim(),
      Narration1: couponDetail.narration1,
      Narration2: couponDetail.narration2,
      Narration3: couponDetail.narration3,
      UserCd: vRdxuserInfo?.UserID || "",
    };
    const response = await onGetMobileCoupon_Update(
      fcheck_null_undefine_replace_empty(obj)
    );
    if (response?.status === 200) {
      fAlertToast("SUCCESS", response?.data?.Type);
      handleReset();
      setSaving(false);
    } else {
      setSaving(false);
    }
  };

  // onClick handler for Delete button
  const handleDelete = async () => {
    let iValidateDetail = validateInputs();
    if (!iValidateDetail) return;

    const obj = {
      MobileNumber: couponDetail.mobileNumber,
      CouponNumber: couponDetail.couponNumber,
    };

    const response = await onGetMobileCoupon_Delete(
      fcheck_null_undefine_replace_empty(obj)
    );
    if (response?.status === 200) {
      fAlertToast("SUCCESS", response?.data?.Type);
      handleReset();
    }
  };

  const handleReset = () => {
    setCouponError("");
    setMobileError("");
    setNarration1Error("");
    setCouponDetail(intialState);
    setGridData([]);
    setTimeout(() => {
      mobileInputRef.current?.focus();
    }, 0);
  };
  return (
    <Box>
      <Grid container spacing={0.5}>
        <Grid item xs={12} sm={4}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <TextField
              label="Mobile Number"
              value={couponDetail.mobileNumber}
              size="small"
              inputRef={mobileInputRef}
              onKeyUp={(e) => {
                fKeyTabInput(e, "couponNumber");
              }}
              onChange={(e) => {
                setCouponDetail({
                  ...couponDetail,
                  mobileNumber: e.target.value,
                });
                if (mobileError && mobileRegex.test(e.target.value.trim())) {
                  setMobileError("");
                }
                setGridData([]);
              }}
              onBlur={handleMobileBlur}
              placeholder="Mobile Number"
              error={!!mobileError}
              helperText={mobileError}
            />

            <TextField
              name="couponNumber"
              label="Coupon Number"
              value={couponDetail.couponNumber}
              size="small"
              onKeyUp={(e) => {
                fKeyTabInput(e, "narration1");
              }}
              onChange={(e) => {
                setCouponDetail({
                  ...couponDetail,
                  couponNumber: e.target.value,
                });
                if (couponError && e.target.value.trim()) {
                  setCouponError("");
                }
              }}
              onBlur={handleCouponBlur}
              error={!!couponError}
              helperText={couponError}
            />
            <TextField
              label="Fazaa Card Number"
              size="small"
              value={couponDetail.narration1}
              name="narration1"
              onKeyUp={(e) => {
                fKeyTabInput(e, "narration2");
              }}
              onChange={(e) => {
                setCouponDetail({
                  ...couponDetail,
                  narration1: e.target.value,
                });
                if (narration1Error && e.target.value.trim()) {
                  setNarration1Error("");
                }
              }}
              onBlur={handleFazaaBlur}
              error={!!narration1Error}
              helperText={narration1Error}
            />
            <TextField
              label="Narration 2"
              size="small"
              value={couponDetail.narration2}
              name="narration2"
              onKeyUp={(e) => {
                fKeyTabInput(e, "narration3");
              }}
              onChange={(e) =>
                setCouponDetail({
                  ...couponDetail,
                  narration2: e.target.value,
                })
              }
            />
            <TextField
              label="Narration 3"
              size="small"
              value={couponDetail.narration3}
              name="narration3"
              onKeyUp={(e) => {
                if (e.key === "Enter") {
                  document?.getElementsByName("narration3")[0]?.blur();
                  handleSave();
                }
              }}
              onChange={(e) =>
                setCouponDetail({
                  ...couponDetail,
                  narration3: e.target.value,
                })
              }
            />
            {/* Buttons Row */}
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}
            >
              <Button
                variant="outlined"
                onClick={handleDelete}
                disabled={saving}
              >
                Delete
              </Button>
              <Button
                variant="contained"
                onClick={handleSave}
                disabled={saving}
              >
                {saving ? "Saving..." : "Save"}
              </Button>
              <Button
                variant="outlined"
                onClick={handleReset}
                disabled={saving}
              >
                Reset
              </Button>
            </Box>
          </Box>
        </Grid>

        <Grid item xs={12} sm={8}>
          <Box style={{ height: "100%", width: "100%" }} minHeight={"30vh"}>
            {/* First Grid */}
            <DataGrid
              rowHeight={20}
              headerHeight={30}
              rows={gridData}
              columns={rowsColumn}
              getRowId={(row) => row.CouponNumber}
              hideFooter={gridData.length < 100}
              loading={loading}
              onRowClick={(params) => {
                setCouponError("");
                setMobileError("");
                setNarration1Error("");
                setCouponDetail((prev) => ({
                  ...prev,
                  mobileNumber: params?.row?.MobileNumber,
                  couponNumber: params?.row?.CouponNumber,
                  narration1: params?.row?.Narration1,
                  narration2: params?.row?.Narration2,
                  narration3: params?.row?.Narration3,
                }));
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default MobileCoupon;
